var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading-spinner"}},[_c('div',{class:_vm.showHide,attrs:{"id":"spinner-front"}},[_c('img',{attrs:{"src":require("../assets/805.svg")}})]),_c('div',{class:_vm.showHide,attrs:{"id":"spinner-back"}})])}
var staticRenderFns = []

export { render, staticRenderFns }